import { provideState } from '@ngrx/store';
import * as AcademicActions from './academic.actions';
import * as fromAcademic from './academic.reducer';
import * as AcademicSelectors from './academic.selectors';
import { featureKey } from './academic.selectors';

export { AcademicActions, AcademicSelectors };

export const academicStoreProviders = [provideState(featureKey, fromAcademic.reducer)];
